import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './OrgaPdfItem.styles';
import { notification } from 'antd';
import {
  refreshOrgaById,
  selectIsUserUpdating,
  selectSelectedUser,
} from '../../redux/store/userData/users';
import LoadingIcon from '../shared/LoadingIcon';

interface Props {
  linkName?: string;
  uri: string;
}

const OrgaPdfItem: React.FC<Props> = ({ linkName, uri }) => {
  const dispatch = useDispatch();
  const selectedUser = useSelector(selectSelectedUser);
  const isUserUpdating = useSelector(selectIsUserUpdating);

  const onClickDownload = () => {
    window.open(uri);
  };

  const onClickRefresh = () => {
    if (selectedUser.id) dispatch(refreshOrgaById(selectedUser.id));
  };

  const copyInvoiceLink = () => {
    const el = document.createElement('textarea');
    // @ts-ignore
    el.value = uri;
    document.body.appendChild(el);
    el.focus();
    el.select();
    try {
      document.execCommand('copy');
      document.body.removeChild(el);
      notification.success({
        message: 'Pdf link Copied',
        style: {
          whiteSpace: 'pre',
        },
      });
    } catch (err) {
      console.log('Oops, unable to copy');
    }
  };

  return (
    <>
      <div className="wrapper">
        <a
          className={uri ? 'link' : ''}
          href={uri}
          target="_blank"
          rel="noreferrer"
        >
          {uri ? linkName : '-'}
        </a>
        <div className="receipt-actions">
          {!isUserUpdating ? (
            <img
              onClick={onClickRefresh}
              src={'/images/drawer/reload.svg'}
              alt="reload"
              style={{
                cursor: 'pointer',
                marginTop: 4,
                marginRight: 10,
                width: 15,
                height: 15,
                color: '#0077be',
              }}
            />
          ) : (
            <LoadingIcon
              font={18}
              style={{
                marginRight: 10,
                width: 12,
                height: 12,
              }}
            />
          )}

          {uri && (
            <img
              src={'/images/car-editor/location.svg'}
              alt="location"
              onClick={copyInvoiceLink}
              style={{ cursor: 'pointer', marginRight: 10 }}
            />
          )}
          {uri && (
            <img
              onClick={onClickDownload}
              src={'/images/drawer/download.svg'}
              alt="download"
            />
          )}
        </div>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

OrgaPdfItem.defaultProps = {
  linkName: 'PDF',
};

export default OrgaPdfItem;
